/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Start_AriaInputs */

const en_batch_subtitle_export_start_aria = /** @type {(inputs: Batch_Subtitle_Export_Start_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start batch export`)
};

const fr_batch_subtitle_export_start_aria = /** @type {(inputs: Batch_Subtitle_Export_Start_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrer l’exportation par lot`)
};

const de_batch_subtitle_export_start_aria = /** @type {(inputs: Batch_Subtitle_Export_Start_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stapelexport starten`)
};

const it_batch_subtitle_export_start_aria = /** @type {(inputs: Batch_Subtitle_Export_Start_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvia l'esportazione in batch`)
};

const ru_batch_subtitle_export_start_aria = /** @type {(inputs: Batch_Subtitle_Export_Start_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать пакетный экспорт`)
};

const es_batch_subtitle_export_start_aria = /** @type {(inputs: Batch_Subtitle_Export_Start_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar exportación por lotes`)
};

const zh_cn2_batch_subtitle_export_start_aria = /** @type {(inputs: Batch_Subtitle_Export_Start_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始批量导出`)
};

const ja_batch_subtitle_export_start_aria = /** @type {(inputs: Batch_Subtitle_Export_Start_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一括エクスポートを開始`)
};

const hi_batch_subtitle_export_start_aria = /** @type {(inputs: Batch_Subtitle_Export_Start_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैच निर्यात शुरू करें`)
};

const pt_pt2_batch_subtitle_export_start_aria = /** @type {(inputs: Batch_Subtitle_Export_Start_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar exportação em lote`)
};

/**
* | output |
* | --- |
* | "Start batch export" |
*
* @param {Batch_Subtitle_Export_Start_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_start_aria = /** @type {((inputs?: Batch_Subtitle_Export_Start_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Start_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_subtitle_export_start_aria(inputs)
	if (locale === "de") return de_batch_subtitle_export_start_aria(inputs)
	if (locale === "it") return it_batch_subtitle_export_start_aria(inputs)
	if (locale === "ru") return ru_batch_subtitle_export_start_aria(inputs)
	if (locale === "es") return es_batch_subtitle_export_start_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_subtitle_export_start_aria(inputs)
	if (locale === "ja") return ja_batch_subtitle_export_start_aria(inputs)
	if (locale === "hi") return hi_batch_subtitle_export_start_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_subtitle_export_start_aria(inputs)
	return en_batch_subtitle_export_start_aria(inputs)
});